import { PERMISSIONS } from '../rbac/permissions.js';
/**
 * WebSocket protocol: snapshot + delta with sequence numbers.
 *
 * Re-pushing whole dashboard state on every tick is what makes "real-time"
 * NOC screens melt a browser when 400 alarms land at once. Clients get one
 * snapshot on subscribe, then JSON Patch deltas, and detect loss by sequence
 * gap rather than by hoping.
 */
export const WS_TOPICS = {
    NOC_SUMMARY: 'noc:summary',
    ALARMS_ALL: 'alarms:all',
    INCIDENTS_ALL: 'incidents:all',
    DEVICES_STATUS: 'devices:status',
    SYSTEM_NOTICE: 'system:notice',
};
export const topicAlarmsBySite = (siteId) => `alarms:site:${siteId}`;
export const topicAlarmsBySeverity = (severity) => `alarms:severity:${severity}`;
export const topicIncident = (incidentId) => `incident:${incidentId}`;
export const topicJobsForTech = (userId) => `jobs:tech:${userId}`;
export const topicReportRun = (runId) => `reports:run:${runId}`;
/**
 * Permission required to subscribe to a topic pattern.
 *
 * Checked at subscribe time **and re-checked when a user's permissions
 * change** — a role downgrade must not leave a socket streaming data the user
 * can no longer see.
 */
export const TOPIC_PERMISSIONS = [
    { pattern: /^noc:summary$/, permission: PERMISSIONS.NOC_DASHBOARD_READ },
    { pattern: /^alarms:/, permission: PERMISSIONS.ALARM_READ },
    { pattern: /^incidents?:/, permission: PERMISSIONS.INCIDENT_READ },
    { pattern: /^devices:/, permission: PERMISSIONS.DEVICE_READ },
    { pattern: /^jobs:tech:/, permission: PERMISSIONS.JOB_READ },
    { pattern: /^reports:run:/, permission: PERMISSIONS.REPORT_READ },
    { pattern: /^system:notice$/, permission: PERMISSIONS.NOC_DASHBOARD_READ },
];
export function permissionForTopic(topic) {
    return TOPIC_PERMISSIONS.find((t) => t.pattern.test(topic))?.permission ?? null;
}
/**
 * Per-topic coalescing key.
 *
 * If a client is slow, deltas that touch the same key collapse so it receives
 * the latest state rather than an ever-growing backlog. Without this, one
 * stalled browser tab during an alarm storm turns into unbounded server
 * memory.
 */
export function coalesceKey(topic, patch) {
    return `${topic}:${patch.map((p) => p.path).join(',')}`;
}
export const WS_HEARTBEAT_MS = 25_000;
/** Drop a socket that has not answered two consecutive heartbeats. */
export const WS_TIMEOUT_MS = 60_000;
//# sourceMappingURL=index.js.map